import LocizeBackend from 'i18next-locize-backend';

import { LOCIZE_PROJECT_ID, LOCIZE_VERSION } from './config';

export const createLocizeBackend = () =>
  new LocizeBackend({
    projectId: LOCIZE_PROJECT_ID,
    version: LOCIZE_VERSION,
    cdnType: 'pro',
  });

export const warnCdnReadFailure = (language: string, namespace: string, error: unknown) => {
  console.warn(
    `i18n CDN 번역 조회 실패 - ${language}/${namespace}: ${
      error instanceof Error ? error.message : String(error)
    }`,
  );
};
